import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { Team_Permission } from 'generated/types';
import { flatten, map, pipe, uniq } from 'ramda';
export var SUBJECTS;
(function (SUBJECTS) {
    SUBJECTS["INTAKE_QUEUE"] = "IntakeQueue";
    SUBJECTS["INTAKE_GROUP"] = "IntakeGroup";
    SUBJECTS["INTAKE_TAG"] = "IntakeTag";
    SUBJECTS["BULK_TICKETS"] = "BulkTickets";
    SUBJECTS["BULK_INTERACTIONS"] = "BulkInteractions";
    SUBJECTS["BULK_DELIVERABLES"] = "BulkDeliverables";
    SUBJECTS["BULK_REASSIGN"] = "BulkReassign";
    SUBJECTS["BULK_STATUS"] = "BulkStatus";
    SUBJECTS["COST_ESTIMATES"] = "CostEstimates";
    SUBJECTS["TICKETS"] = "Tickets";
    SUBJECTS["CARE_PODS"] = "CarePods";
    SUBJECTS["ClAIMS"] = "Claims";
    SUBJECTS["TASKS"] = "Tasks";
    SUBJECTS["INTERACTIONS"] = "Interactions";
    SUBJECTS["INSURANCE_PLANS"] = "InsurancePlans";
    SUBJECTS["ORGANIZATIONS"] = "Organizations";
    SUBJECTS["ORGANIZATION_GROUPS"] = "OrganizationGroups";
    SUBJECTS["PARTNER_CARDS"] = "PartnerCards";
    SUBJECTS["DOCUMENTS"] = "Documents";
    SUBJECTS["TEAMS"] = "Teams";
    SUBJECTS["PHARMACY_PLANS"] = "PharmacyPlans";
    SUBJECTS["USERS"] = "Users";
    SUBJECTS["LIBRARY"] = "Library";
    SUBJECTS["PBM_NOTES"] = "PbmNotes";
    SUBJECTS["INVITES"] = "Invites";
    SUBJECTS["EMPLOYEES"] = "Employees";
    SUBJECTS["ORG_LAUNCHER"] = "OrgLauncher";
    SUBJECTS["ADMIN"] = "Admin";
    SUBJECTS["COPILOT_CLASSIFIER"] = "CopilotClassifier";
    SUBJECTS["COPILOT_MEMBER_SUMMARIES"] = "CopilotMemberSummaries";
    SUBJECTS["COPILOT_CHAT_SUMMARIES"] = "CopilotChatSummaries";
    SUBJECTS["TICKET_SETTINGS"] = "TicketSettings";
})(SUBJECTS || (SUBJECTS = {}));
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["CREATE"] = "create";
    ACTIONS["READ"] = "read";
    ACTIONS["UPDATE"] = "update";
    ACTIONS["DESTROY"] = "destroy";
})(ACTIONS || (ACTIONS = {}));
export var defineAbilityFor = function (teamsPermission) {
    var _a = new AbilityBuilder(createMongoAbility), can = _a.can, build = _a.build;
    if (!(teamsPermission === null || teamsPermission === void 0 ? void 0 : teamsPermission.length))
        return build();
    if (teamsPermission.includes(Team_Permission.AccessAdmin)) {
        can(ACTIONS.READ, SUBJECTS.ADMIN);
        can(ACTIONS.READ, SUBJECTS.TEAMS);
        can(ACTIONS.READ, SUBJECTS.ORGANIZATION_GROUPS);
        can(ACTIONS.READ, SUBJECTS.TICKET_SETTINGS);
        can(ACTIONS.CREATE, SUBJECTS.BULK_TICKETS);
        can(ACTIONS.CREATE, SUBJECTS.BULK_INTERACTIONS);
        can(ACTIONS.CREATE, SUBJECTS.BULK_DELIVERABLES);
        can(ACTIONS.CREATE, SUBJECTS.BULK_REASSIGN);
        can(ACTIONS.CREATE, SUBJECTS.BULK_STATUS);
    }
    if (teamsPermission.includes(Team_Permission.AccessOrgLauncher))
        can(ACTIONS.READ, SUBJECTS.ORG_LAUNCHER);
    if (teamsPermission.includes(Team_Permission.ManageIntakeQueues)) {
        can(ACTIONS.READ, SUBJECTS.INTAKE_QUEUE);
        can(ACTIONS.READ, SUBJECTS.INTAKE_GROUP);
    }
    if (teamsPermission.includes(Team_Permission.ManageIntakeTags)) {
        can(ACTIONS.READ, SUBJECTS.INTAKE_TAG);
    }
    if (teamsPermission.includes(Team_Permission.AccessBenefitManager))
        can(ACTIONS.READ, SUBJECTS.COST_ESTIMATES);
    if (teamsPermission.includes(Team_Permission.AccessNavigationAdvanced)) {
        can(ACTIONS.READ, SUBJECTS.PARTNER_CARDS);
        can(ACTIONS.UPDATE, SUBJECTS.ORGANIZATIONS);
    }
    if (teamsPermission.includes(Team_Permission.ViewTickets))
        can(ACTIONS.READ, SUBJECTS.TICKETS);
    if (teamsPermission.includes(Team_Permission.ManageTickets))
        can(ACTIONS.UPDATE, SUBJECTS.TICKETS);
    if (teamsPermission.includes(Team_Permission.ViewTasks))
        can(ACTIONS.READ, SUBJECTS.TASKS);
    if (teamsPermission.includes(Team_Permission.ManageTasks))
        can(ACTIONS.UPDATE, SUBJECTS.TASKS);
    if (teamsPermission.includes(Team_Permission.ViewClaims))
        can(ACTIONS.READ, SUBJECTS.ClAIMS);
    if (teamsPermission.includes(Team_Permission.ManageClaims))
        can(ACTIONS.UPDATE, SUBJECTS.ClAIMS);
    if (teamsPermission.includes(Team_Permission.ViewCarePods))
        can(ACTIONS.READ, SUBJECTS.CARE_PODS);
    if (teamsPermission.includes(Team_Permission.ViewInsurancePlans))
        can(ACTIONS.READ, SUBJECTS.INSURANCE_PLANS);
    if (teamsPermission.includes(Team_Permission.AccessPbmJournalNotes)) {
        can(ACTIONS.READ, SUBJECTS.PBM_NOTES);
        can(ACTIONS.UPDATE, SUBJECTS.PBM_NOTES);
    }
    if (teamsPermission.includes(Team_Permission.ViewOrganizations))
        can(ACTIONS.READ, SUBJECTS.ORGANIZATIONS);
    if (teamsPermission.includes(Team_Permission.ViewInteractions))
        can(ACTIONS.READ, SUBJECTS.INTERACTIONS);
    if (teamsPermission.includes(Team_Permission.ViewUploads))
        can(ACTIONS.READ, SUBJECTS.DOCUMENTS);
    if (teamsPermission.includes(Team_Permission.ViewPharmacyPlan))
        can(ACTIONS.READ, SUBJECTS.PHARMACY_PLANS);
    if (teamsPermission.includes(Team_Permission.ManagePharmacyPlan)) {
        can(ACTIONS.READ, SUBJECTS.PHARMACY_PLANS);
        can(ACTIONS.UPDATE, SUBJECTS.PHARMACY_PLANS);
    }
    if (teamsPermission.includes(Team_Permission.ViewUsers))
        can(ACTIONS.READ, SUBJECTS.USERS);
    if (teamsPermission.includes(Team_Permission.ManageUsers)) {
        can(ACTIONS.UPDATE, SUBJECTS.USERS);
    }
    if (teamsPermission.includes(Team_Permission.ViewArticles))
        can(ACTIONS.READ, SUBJECTS.LIBRARY);
    if (teamsPermission.includes(Team_Permission.ManageArticles)) {
        can(ACTIONS.CREATE, SUBJECTS.LIBRARY);
        can(ACTIONS.UPDATE, SUBJECTS.LIBRARY);
        can(ACTIONS.DESTROY, SUBJECTS.LIBRARY);
    }
    if (teamsPermission.includes(Team_Permission.ViewInvites))
        can(ACTIONS.READ, SUBJECTS.INVITES);
    if (teamsPermission.includes(Team_Permission.CreateInvites))
        can(ACTIONS.CREATE, SUBJECTS.INVITES);
    if (teamsPermission.includes(Team_Permission.ViewEmployees))
        can(ACTIONS.READ, SUBJECTS.EMPLOYEES);
    if (teamsPermission.includes(Team_Permission.AdministerEmployees))
        can(ACTIONS.CREATE, SUBJECTS.EMPLOYEES);
    if (teamsPermission.includes(Team_Permission.AccessCopilotClassifier))
        can(ACTIONS.READ, SUBJECTS.COPILOT_CLASSIFIER);
    if (teamsPermission.includes(Team_Permission.AccessCopilotMemberSummaries))
        can(ACTIONS.READ, SUBJECTS.COPILOT_MEMBER_SUMMARIES);
    if (teamsPermission.includes(Team_Permission.AccessCopilotChatSummaries))
        can(ACTIONS.READ, SUBJECTS.COPILOT_CHAT_SUMMARIES);
    return build();
};
export var collectTeamsPermissions = function (teams) {
    if (!(teams === null || teams === void 0 ? void 0 : teams.length))
        return [];
    return pipe(map(function (team) { return team.permissions; }), flatten, uniq)(teams);
};
